import { comparisonOptions, getAlertMetricLabel, IConversion, ICustomAlert, IFeed_Alert } from "../../dashboard/alerts/alerts"
import { format } from 'date-fns'
import { formatNumber, formatNumberLocale, getColor } from "../../../_utils"

const getStatusColor = (status: string) => {
    switch (status) {
        case 'approved': return 'success'
        case 'rejected': return 'danger'
        default: return 'secondary'
    }
}
const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)
const reportBlue = '#5b9bd5'

function AlertSectionHeading(opts: { title: string }) {
    return (
        <div className="mb-2">
            <h6 className="mb-2 fw-bold text-uppercase" style={{ color: reportBlue, fontSize: '0.95rem', letterSpacing: '0.02em' }}>
                {opts.title}
            </h6>
        </div>
    )
}

export function renderDuplicate(orderRef: string, conversions: IConversion[], currency: string, includeHeader: boolean) {
    const latestConversion = conversions.reduce((latest, curr) => {
        return new Date(curr.date) > new Date(latest.date) ? curr : latest
    }, conversions[0])
    const formattedDate = format(new Date(latestConversion.date), 'yyyy-MM-dd HH:mm')

    return (
        <div key={orderRef}>
            {includeHeader ? <AlertSectionHeading title="Duplicate Conversions" /> : null}
            <div className="mb-2">
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <h6 className="mb-0">Order Ref: {orderRef}</h6>
                    <small className="text-muted">{formattedDate}</small>
                </div>
                <div className="border rounded p-2">
                    {conversions.slice(0,5).map((conv, idx) => (
                        <div key={idx} className={"d-flex " + (idx !== conversions.length-1 ? 'mb-2' : '')}>
                            <div style={{ width: '140px', minWidth: '140px' }}>
                                <img
                                    src={`/flags/${conv.country.toLowerCase()}.svg`}
                                    alt={conv.country}
                                    style={{ height: '15px', marginRight: '5px' }}
                                />
                                <strong style={{ color: getColor(conv.network, 0) }}>
                                    {conv.network}
                                </strong>
                            </div>
                            <strong className="ms-1">{formatNumber(conv.orderAmount, currency)}</strong>
                            <span className="ms-1">- {conv.campaignName}</span>
                            <span className="ms-1">- {conv.affiliateName}</span>
                            <span className={`badge bg-${getStatusColor(conv.status)} ms-auto`} style={{ height: '22px', maxHeight: '22px' }}>
                                {capitalize(conv.status)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export function renderFeed(feed: IFeed_Alert, idx:string, includeHeader: boolean) {
    const formattedDate = format(new Date(feed.date), 'yyyy-MM-dd HH:mm')

    return (
        <div key={idx}>
            {includeHeader ? <AlertSectionHeading title="Feed Alerts" /> : null}
            <div className="mb-2">
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <h6 className="mb-0">Update Error</h6>
                    <small className="text-muted">{formattedDate}</small>
                </div>
                <div className="border rounded p-2">
                    <div><strong>Feed Name:</strong> {feed.feedName} → {feed.linkName}</div>
                    <div>
                        <strong>Error:</strong>{" "}
                        <i
                            style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block',
                            maxWidth: 'calc(100% - 80px)', // justér afhængigt af "Error:" label
                            verticalAlign: 'bottom',
                            }}
                        >
                            {feed.error}
                        </i>
                    </div>

                </div>
            </div>
        </div>
    )
}

export function renderCustom(alert:ICustomAlert, idx:string, includeHeader: boolean, currency: string) {
    const isIncrease = alert.direction === 'increase'
    const dirText = isIncrease ? 'Gain' : 'Drop'
    const dirColor = isIncrease ? 'success' : 'danger'
    const metricLabel = getAlertMetricLabel(alert.metric)
    const percentage = `${isIncrease ? '+' : ''}${formatNumberLocale(alert.percentage, 1)}%`
    const comparisonPeriod = comparisonOptions.find(opt => opt.value === alert.comparisonPeriod)?.label || alert.comparisonPeriod
    const formattedP1 = alert.metric === 'clicks'
        ? formatNumberLocale(alert.period1Value, 0)
        : formatNumber(alert.period1Value, currency)
    const formattedP2 = alert.metric === 'clicks'
        ? formatNumberLocale(alert.period2Value, 0)
        : formatNumber(alert.period2Value, currency)
    const formattedDate = format(new Date(alert.date), 'yyyy-MM-dd HH:mm')

    return (
        <div key={idx}>
            {includeHeader ? <AlertSectionHeading title="Custom Alerts" /> : null}
            <div className="mb-2">
                <div className="d-flex justify-content-between align-items-center mb-1">
                    <h6 className="mb-0">{metricLabel} {dirText}</h6>
                    <small className="text-muted">{formattedDate}</small>
                </div>
                <div className="border rounded p-2">
                    <div className="mb-2"><strong>Alert name:</strong> {alert.name}</div>
                    <div>
                        <strong>Change:</strong> {comparisonPeriod} {dirText.toLowerCase()} by{' '}
                        <span className={`text-${dirColor}`}>
                            <strong>{percentage}</strong>
                        </span>
                        <span className="ms-2">
                            <small>({formattedP2} → {formattedP1})</small>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}
